$(document).ready(function(){
  $('.sticky-header').css({
    'top': $('header').height(),
  });

});
